'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../dist-es6/client/dtos/userInfo');let

UserService=function(_BaseService){_inherits(UserService,_BaseService);
function UserService($state,cookieRefresherService,$window,socketService,displaySettingsService,groupBasedDataHelperService,Analytics,errorHandlers,fatigueMeterTypeContentProviderService){_classCallCheck(this,UserService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$state=$state;
_this._cookieRefresherService=cookieRefresherService;
_this._$window=$window;
_this._socketService=socketService;
_this._displaySettingsService=displaySettingsService;
_this._groupBasedDataHelperService=groupBasedDataHelperService;
_this._analytics=Analytics;
_this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

_this._currentUser=void 0;
errorHandlers.getCurrentUser=function(){return _this._currentUser};return _this;
}UserService.prototype.

logout=function(){var ref=_asyncToGenerator(function*(){
try{
let socketResponse=yield this._socketService.sendAndWaitForResponse('EndUserSession');

if(SocketResponse.succeeded(socketResponse)&&_.exists(socketResponse,'body.redirect')){
this._$window.location=socketResponse.body.redirect;
return;
}
}catch(e){

}finally{
if(_.exists(this._currentUser)){
this._analytics.trackEvent('session','logout',this._currentUser.email);
}
}


this._bounceToLogin();
});function logout(){return ref.apply(this,arguments)}return logout}();UserService.prototype.

_processResponse=function _processResponse(userDataSocketResponse,trackingLabel){
if(!SocketResponse.succeeded(userDataSocketResponse)){
return;
}

const{userInfo:userInfo,displaySettings:displaySettings}=userDataSocketResponse.body;

this._currentUser=UserInfo.fromJSON(userInfo);

if(_.exists(displaySettings)){
this._displaySettingsService.incorporateLatestSettingsFromBackend(displaySettings);
}

const fatigueMeterType=_.get(this._currentUser,'fatigueMeterType');
this._groupBasedDataHelperService.updateFatigueMeterType(fatigueMeterType);
this._fatigueMeterTypeContentProviderService.updateProvidedContentToType(fatigueMeterType);

this._analytics.trackEvent('session',trackingLabel,this._currentUser.email);
};UserService.prototype.

_bounceToLogin=function _bounceToLogin(){




this._$state.go('fdc.features.login',{});
this.clearAllUserData();

};UserService.prototype.

clearAllUserData=function clearAllUserData(){
this._currentUser=void 0;
this._groupBasedDataHelperService.resetAllData();
};UserService.prototype.

beginUserSession=function(){var ref=_asyncToGenerator(function*(loginRequest){
if(this._onLoginScreen){
this.clearAllUserData();
}

yield this._cookieRefresherService.refreshCookieImmediate();
yield this._socketService.reconnect();
const userDataSocketResponse=yield this._socketService.sendAndWaitForResponse('BeginUserSession',loginRequest,{keepSessionAlive:!1});
yield this._cookieRefresherService.refreshCookieImmediate();
this._processResponse(userDataSocketResponse,'login');

return userDataSocketResponse;
});function beginUserSession(loginRequest){return ref.apply(this,arguments)}return beginUserSession}();UserService.prototype.

continueUserSession=function(){var ref=_asyncToGenerator(function*(){
const userDataSocketResponse=yield this._socketService.sendAndWaitForResponse('ContinueUserSession');

this._processResponse(userDataSocketResponse,'continue');

if(!SocketResponse.succeeded(userDataSocketResponse)){
this._bounceToLogin();
}

return userDataSocketResponse;
});function continueUserSession(){return ref.apply(this,arguments)}return continueUserSession}();UserService.prototype.





updateCurrentUserInfo=function(){var ref=_asyncToGenerator(function*(userData){
let userDataSocketResponse=yield this._socketService.sendAndWaitForResponse('UpdateCurrentUserInfo',userData);
if(SocketResponse.succeeded(userDataSocketResponse)){
this._processResponse(userDataSocketResponse,'changeUserInfo');
}
return userDataSocketResponse;
});function updateCurrentUserInfo(userData){return ref.apply(this,arguments)}return updateCurrentUserInfo}();UserService.prototype.

changePassword=function(){var ref=_asyncToGenerator(function*(passwordRequest){
return yield this._socketService.sendAndWaitForResponse('ResetCurrentUserPassword',passwordRequest);
});function changePassword(passwordRequest){return ref.apply(this,arguments)}return changePassword}();_createClass(UserService,[{key:'currentUser',get:function(){return this._currentUser}},{key:'_onLoginScreen',get:function()

{
return this._$state.current.name==='fdc.features.login';
}}]);return UserService}(BaseService);


module.exports=UserService;
//# sourceMappingURL=userService.js.map
